import { render, staticRenderFns } from "./BravoProjectSection.vue?vue&type=template&id=df229100&scoped=true&"
import script from "./BravoProjectSection.vue?vue&type=script&lang=js&"
export * from "./BravoProjectSection.vue?vue&type=script&lang=js&"
import style0 from "./BravoProjectSection.vue?vue&type=style&index=0&id=df229100&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df229100",
  null
  
)

export default component.exports